
// The summary page's fallback guard (Aziz 2026-09-30): the automatic
// countersignature rides the summary send, so this is for a recommendation
// that is not going out through Flow, and for the send-time signing having
// failed. Reads the client's latest SOA within 60 days -- the store's
// `soa60days`, which the page already loads -- and calls the agent-side
// countersign endpoint (flow/consults/endpoints/survey.py). The single-SOA page
// (/survey/{uid}/soa/{id}) guards the SOA it shows instead (2026-10-03).
import { countersignSoa, soaSigningState } from '~/util/soa'

export default {
    props: {
        client: { type: Object, required: true },
        soa: { type: Object, default: null },
    },
    data () {
        return { signing: false }
    },
    computed: {
        value () { return (this.soa && this.soa.value) || {} },
        state () { return soaSigningState(this.soa) },
        clientSignedOn () {
            return this.day(this.value.client_sign_date || this.value.agent_sign_date || (this.soa && this.soa.created))
        },
        agentSignedOn () { return this.day(this.value.agent_sign_date) },
        pdfUrl () {
            return this.soa ? this.$api.signedSoaPdfUrl(this.client.id, this.soa.key) : null
        },
    },
    methods: {
        day (v) {
            if (!v) { return '' }
            const m = this.$moment(v)
            return m.isValid() ? m.format('MMMM D, YYYY') : ''
        },
        async sign () {
            if (this.signing || !this.soa) { return }
            this.signing = true
            const resp = await countersignSoa(this, this.client.id, this.soa)
            this.signing = false
            if (resp) { this.$emit('signed', resp) }
        },
    },
}
